import { AdhesionMode } from '../api/users/getAdhesionDetails';
import { UserPlanI } from '../api/users/getPlans';

/**
 * `mode` con el que la vista Personal pide los datos del plan elegido.
 *
 * Manda el TIPO del plan; `fallback` (lo que digan los flags del usuario) solo
 * decide cuando el tipo no se conoce. No es una preferencia de estilo: `mode` y
 * `userEppConfigId` viajan juntos y el backend los cruza
 * (`findOne({ userId, type, id })`). Si el plan elegido es INDIVIDUAL y se manda
 * FREELANCE, no hay fila que casar y la respuesta es un 400 con la pantalla en
 * blanco — incidente PROD del 02-sep-2026, en una persona con `is_freelance =
 * true` y dos planes personales de tipo distinto.
 *
 * Solo se aceptan los dos tipos PERSONALES. Un `EMPLOYMENT` aquí solo puede ser
 * un error del caller —es la vista Personal—, y traducirlo pediría a Caser el
 * plan de la EMPRESA desde la pantalla del plan propio: se ignora y decide el
 * fallback.
 *
 * Vive aquí, y no copiado en cada vista, porque es la regla que causó aquel
 * incidente: un arreglo en una copia no llegaría a las demás.
 */
export function resolvePersonalAdhesionMode<F extends AdhesionMode | null>(
	planType: UserPlanI['type'] | undefined,
	fallback: F
): AdhesionMode | F {
	return isPersonalPlanType(planType) ? planType : fallback;
}

/**
 * ¿Se conoce el tipo PERSONAL del plan? Solo entonces puede viajar su id: el
 * `mode` sale de ese tipo y el backend casa la fila. Sin él, el `mode` sale de
 * los flags del usuario, y mandar además el id cruzaría un tipo que puede no
 * ser el del plan — el 400 del 02-sep-2026. Sin tipo se pide solo por modo,
 * como antes de que existiera el selector.
 */
export function isPersonalPlanType(
	planType: UserPlanI['type'] | undefined
): planType is 'INDIVIDUAL' | 'FREELANCE' {
	return planType === 'INDIVIDUAL' || planType === 'FREELANCE';
}
